import { render, staticRenderFns } from "./cart.vue?vue&type=template&id=1d90a1cc&scoped=true&"
import script from "./cart.vue?vue&type=script&lang=js&"
export * from "./cart.vue?vue&type=script&lang=js&"
import style0 from "./cart.vue?vue&type=style&index=0&id=1d90a1cc&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d90a1cc",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Cart: require('/app/components/cart/cart.vue').default})
